import type { Config } from '../../_config'
import type { ID } from '../../_kernel/ID'
import type { ListOfID } from '../../_kernel/ListOfID'
import type { ListOfPaginatedID } from '../../_kernel/ListOfPaginatedID'
import type { ListOfProperty } from '../domain/ListOfProperty'
import type { ListOfTheme } from '../domain/ListOfTheme'
import type { LikeBelong } from '../domain/LikeBelong'
import type {
  deleteLikeInput,
  findByIDsInput,
  getBannerPropertiesInput,
  getThemesInput,
  getUserLikesIdsInput,
  isLikedInput,
  PropertyRepository,
  relatedByIDInput,
  saveLastSeenInput,
  saveLikeInput,
} from '../domain/PropertyRepository'
import { CookiePropertyRepository } from './CookiePropertyRepository'
import { HTTPPropertyRepository } from './HTTPPropertyRepository'

export class PropertyRepositoryProxy implements PropertyRepository {
  static create({ config }: { config: Config }) {
    return new PropertyRepositoryProxy(
      HTTPPropertyRepository.create({ config }),
      CookiePropertyRepository.create({ config })
    )
  }

  constructor(
    private readonly remote: HTTPPropertyRepository,
    private readonly local: CookiePropertyRepository
  ) {}

  async saveLastSeenIDs({ ids }: saveLastSeenInput): Promise<ListOfID> {
    return this.local.saveLastSeenIDs({ ids })
  }

  async lastSeenIDs(): Promise<ListOfID> {
    return this.local.lastSeenIDs()
  }

  async findByIDs({ ids, lang }: findByIDsInput): Promise<ListOfProperty> {
    return this.remote.findByIDs({ ids, lang })
  }

  async findByBannerID({
    id,
    lang,
    market,
    partialSearch,
    affiliate,
  }: getBannerPropertiesInput): Promise<ListOfProperty> {
    return this.remote.findByBannerID({
      id,
      lang,
      market,
      partialSearch,
      affiliate,
    })
  }

  async relatedByID({
    id,
    lang,
    market,
    partialSearch,
    affiliate,
    currency,
    country,
  }: relatedByIDInput): Promise<ListOfProperty> {
    return this.remote.relatedByID({
      id,
      lang,
      market,
      partialSearch,
      affiliate,
      currency,
      country,
    })
  }

  async saveLike({ id }: saveLikeInput): Promise<ID> {
    return this.remote.saveLike({ id })
  }

  async deleteLike({ id }: deleteLikeInput): Promise<ID> {
    return this.remote.deleteLike({ id })
  }

  async isLiked({ id }: isLikedInput): Promise<LikeBelong> {
    return this.remote.isLiked({ id })
  }

  async getUserLikesIds({ pagination }: getUserLikesIdsInput): Promise<ListOfPaginatedID> {
    return this.remote.getUserLikesIds({ pagination })
  }

  async getThemes({ lang }: getThemesInput): Promise<ListOfTheme> {
    return this.remote.getThemes({ lang })
  }
}
